// Stripe Professional Directory, Profil KOMMERS. Eine Quelle fuer Footer, TrustBar,
// /about und das Organization-Schema, damit jede Nennung auf denselben pruefbaren
// Nachweis verlinkt. Neues Zertifikat: hier eintragen und die drei i18n-Keys
// (<key>Title, <key>About, <key>LinkLabel) im partner-Namespace ergaenzen.
export type StripeCertification = {
  /** Praefix der i18n-Keys im partner-Namespace. */
  key: 'paymentsArchitect' | 'paymentsDeveloper' | 'billingDeveloper' | 'platformDeveloper'
  /** Oeffentlicher Credential-Link (Accredible), Domain stripecertifications.credential.net. */
  url: string
  /** Ausstellungsdatum laut Stripe Professional Directory, ISO fuer das Schema. */
  issued: string
}

export const STRIPE_CERTIFICATIONS: StripeCertification[] = [
  {
    key: 'paymentsArchitect',
    url: 'https://stripecertifications.credential.net/0bd8cad5-107e-46bf-90a0-d4a4225a6b61',
    issued: '2026-09-02'
  },
  {
    key: 'paymentsDeveloper',
    url: 'https://stripecertifications.credential.net/366b7a04-d1f0-4b9a-ac04-9a16538f0bee',
    issued: '2026-09-03'
  },
  {
    key: 'billingDeveloper',
    url: 'https://stripecertifications.credential.net/100aa5c8-82d8-474f-83fd-9ef6b5811b17',
    issued: '2026-09-08'
  },
  {
    key: 'platformDeveloper',
    url: 'https://stripecertifications.credential.net/d969e43e-7602-49fa-b03c-8e042030536c',
    issued: '2026-09-09'
  }
]

/**
 * hasCredential-Block fuer das Organization-Schema. Die Titel kommen aus der
 * Uebersetzung, damit im DE- und EN-Graph derselbe Wortlaut steht wie im Sichtbaren.
 */
export const buildStripeCredentialSchema = (title: (key: string) => string) =>
  STRIPE_CERTIFICATIONS.map((certification) => ({
    '@type': 'EducationalOccupationalCredential',
    name: title(`${certification.key}Title`),
    credentialCategory: 'certificate',
    url: certification.url,
    dateCreated: certification.issued,
    recognizedBy: {
      '@type': 'Organization',
      name: 'Stripe',
      url: 'https://stripe.com'
    }
  }))
